{
  "appointment-history-page": {
    "text": {
      "in-the-past": "In the past or canceled",
      "no-appointment": "You did not book any appointment!",
      "upcoming": "Upcoming appointment"
    },
    "meta": {
      "title": "Appointments",
      "description": "List of booked appointments"
    }
  }
}
